/* eslint-disable no-dupe-keys */
export default {
  point_record: {
    name: '积分记录',
    create_point_record: '赠送/扣减积分',
    // 属性
    prop: {
      trade_number: '单号',
      transaction_type: '赠送或者扣减',
      points: '积分',
      admin: '操作人',
      description: '备注',
      created_at: '创建时间',
      updated_at: '更新时间',
      user: '用户',
      points: '积分',
      user_points: '变化后积分'
    },
    // Enum的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询单号'
    },
    group_titles: {
      base: '基本信息'
    },
    transaction_types: {
      income: '赠送',
      expend: '扣减'
    }
  }
}
